import { DestinationTypeValues } from "../common/ObjectTypes";

export const isHiddenUrlDestinationType = (value: string): boolean => {
    return Object.values(DestinationTypeValues).includes(value as DestinationTypeValues);
};